import { checkboxAnatomy as parts } from '@chakra-ui/anatomy';
import type { PartsStyleObject } from '@chakra-ui/react';

const mbeVariant: PartsStyleObject<typeof parts> = {
  control: {
    borderColor: '#bfbfb0',
    _checked: {
      bg: 'brand.black',
      borderColor: '#bfbfb0',

      _hover: {
        bg: 'brand.black',
        borderColor: '#bfbfb0',
      },
    },
  },
};

export default {
  parts: parts.keys,
  variants: {
    mbe: mbeVariant,
  },
};
